import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { CrudFilters, CrudSort, MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';

class StoreCreditApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/storecredit');
  }

  async usages(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.storeCreditId + '/usages';
      const response = await axiosInstance.get(`${url}`);
      return response.data?.data;
    } catch (error) {
      throw error;
    }
  }
}

export default StoreCreditApiClient;
